import { StyleSheet } from "~/ui/primitives"
import { observer } from "mobx-react-lite";
import styled, { useTheme } from "~/ui/styled"
import { Button, Text, GradientButton, Flex } from '~components/El'

const cells = {
  1: '100%',
  2: '48%',
  3: '31%',
  4: '23%',
  5: '18%'
}

const TabRow = styled(Flex)`
  width: 100%;
  height: auto;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
`

type options = {
    value: string | number;
    label: string;
}
const TypeTabs: React.FC<{
    value: string | number;
    options: options[];
    span?: number;
    onChange: (v: string | number) => void;
}> = ({
        value,
        onChange,
        options = [],
        span = 3
    }) => {
    const theme = useTheme();
    return (
        <TabRow>
            {options.map((v, i) => {
                const active = value === v.value;
                const Wrapper = active ? GradientButton : Button;
                return (
                    <Wrapper
                        key={i}
                        width={cells[span]}
                        height="40px"
                        colors={['#fb994d', '#ee4b49']}
                        borderRadius={8}
                        borderWidth={StyleSheet.hairlineWidth}
                        borderColor={active ? 'transparent' : theme.colors.border}
                        borderStyle="solid"
                        onClick={() => onChange(v.value)}
                    >
                        <Text
                            color={active ? theme.colors.textLight : theme.colors.text}
                            fontWeight={active ? '600' : '400'}
                        >{v.label}</Text>
                    </Wrapper>
                )
            })}
        </TabRow>
    );
};

export default observer(TypeTabs);